import { useEffect, useState, useRef } from "react";
import { Navigate } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { Modal, Row, Col, Form, Card, Button} from 'react-bootstrap'
import { Block, DatePicker, TimePicker, Select } from '../../components';
import Icon from "../Icon/Icon";
import { useApiClient } from "../../ApiService/useApiClient";


const baseURL = "HMCareData/recurringtasks/";


const RecurringTasks = ({CustomerID}) => {

  const dayList = ["Monday","Tuesday", "Wednesday", "Thursday","Friday", "Saturday","Sunday"];

  const api = useApiClient();

  const[data, setdata] = useState(null);  
  const[error, setError] = useState(null); 
  const dataFetchedRef = useRef(false);
  


  //Pop-up Modal Constants
  //==================================================================================
  const formDefault = {
    opened: false,
    action : "add",
  }
  const [formModal, setFormModal] = useState(formDefault);
  const modalForm = useRef(null);
  const [selectedAssignedAgents, setselectedAssignedAgents] = useState(null);
  const[serviceList, setServiceList] = useState(null);
  const[stafflist, setstafflist] = useState(null);  
  const[sDay, setsDay] = useState("");  
  const[runrefresh, setrunrefresh] = useState(false);  
  const [deleteModal, setDeleteModal] = useState(false);
  const [delConfirm, setdelConfirm] = useState(false);


  const ApiGet = async (baseURL1,setdata1, setError1) => {
    try{
    const response = await api.get(baseURL1);
    setdata1(response.data);
    console.log(data);
    } catch(error) {
      setError1(error);      
    }
  };

  //==================================================================================  


  //console.log(baseURL+CustomerID);
  //console.log({ApiCall});

  

    // const getdata = async (url) => { ApiCall.get(url)        
    //     .then((Response)=>{          
    //         setdata(Response.data); 
    //         //console.log(Response.data);
    //        // return null;
    //     }).catch(error => {
    //         setError(error);     
    //         //console.log({error})
    //     });
    // }

    const getStaffList = async (url) => { 

      ApiGet(url, setstafflist, setError);

      //  ApiCall.get(url)        
      // .then((Response)=>{        
      //     setstafflist(Response.data); 
      // }).catch(error => {
      //     setError(error);               
      // });
  }


  const getServiceList = async (url) => { 
    ApiGet(url, setServiceList, setError);
    // ApiCall.get(url)        
    // .then((Response)=>{        
    //     setServiceList(Response.data); 
    // }).catch(error => {
    //     setError(error);               
    // });
}


// function openDeleteModal(){  
//   setDeleteModal(true);
//   setdelConfirm(false); 
// }

// function closeDeleteModal(){
//   setDeleteModal(false);  
// }
// function handleDeleteEvent(){
//   setdelConfirm(true);  
// }



const removeclick = (id)=>{
 
  const frmFormData = new FormData();

      let sURL = "HMCareTask/recurringtask/remove/?id="+id;
            
      api.post(sURL,frmFormData)
      .then((Response)=>{
          
          let UpdatedDataObj = Response.data;    

          if(UpdatedDataObj!=null){
            if(UpdatedDataObj){

              dataFetchedRef.current = false;
              setrunrefresh(!runrefresh);
            }
             
        }      

      }).catch(error => {
          setError(error);     
          //console.log({error})
      });

//    }


}



    useEffect(()=>{   
      
          if (dataFetchedRef.current) return;
          dataFetchedRef.current = true;

          // getdata(baseURL+CustomerID);       
          ApiGet(baseURL+CustomerID, setdata, setError);     

          }, [runrefresh]);


   
    
        if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        if(!data) return (
          <div title="Staff" content="container"><Spinner animation="border" variant="primary" /></div>
          );
  

      
      const RecurringItemDisplay = (item) => (
        <div>
          <div className="small">{item.startTime} - {item.noOfHours} Hour(s)</div>                                    
          <div className="small">{item.productName}</div>                                  
          {item.assignedAgentIds && (
            <div className="small">Carer : {item.assignedAgentIds}</div>
          )}
          <div className="right">
            <span
              style={{ fontSize: "12px", color: "red", cursor: "pointer" }}
              onClick={() => removeclick(item.recurringTaskId)}
            >
              <Icon name="trash" /> Delete
            </span>
          </div> 
          <hr />
        </div>
      );




    //Popup Modal Functions
    //===============================================================================================================    
    const AddButtonClick = (sDay)=>{

        setsDay(sDay);

        //const baseURL3 = "HMCareData/servicelist/";              
        const baseURL3 = "HMCareTask/getcustomerservices/"+CustomerID;              
        !serviceList && getServiceList(baseURL3);    
           
        const baseURL4 = "HMCareStaff/stafflistsummary/"; 
        !stafflist && getStaffList(baseURL4);    

        const updateFormModal = {...formModal, opened:true, modalTitle:sDay, carerAssignmentIds:""}
        setFormModal(updateFormModal);

//console.log(updateFormModal);

    }


    function closeFormModal(){
        const updateFormModal = {...formModal, opened:false}
        setFormModal(updateFormModal);
    }


    function handleAddEvent(e){        
        closeFormModal();
    }

      
    function handleFormSubmit(event){

      event.preventDefault();
      //let newTitle = modalForm.current.querySelector('#eventTitle').value; 
      //let neWDay = modalForm.current.querySelector('#eventDay').value; 
      let newStartTime = modalForm.current.querySelector('#eventStartTime').value;       
      let newEndTime = modalForm.current.querySelector('#eventEndTime').value; 
      let newDescription = modalForm.current.querySelector('#eventDescription').value; 
      let neWServiceType = modalForm.current.querySelector('#ServiceType').value; 
      let neWFundingType = modalForm.current.querySelector('#fundingType').value; 
            
      
      let NewCarerAssignmentIds = selectedAssignedAgents; 
      let neWStartDate = '1899-12-30';//new Date();
      let neWEndDate = '1899-12-30';//new Date();
      

      const frmFormData = new FormData();
      frmFormData.append("CustomerId", CustomerID) // newTitle)
      frmFormData.append("title", "")  
      frmFormData.append("TaskDay", sDay)  
      frmFormData.append("EndTime", neWEndDate + (newEndTime ? 'T' + newEndTime + 'Z' : ''))  
      frmFormData.append("StartTime", neWStartDate + (newStartTime ? 'T' + newStartTime + 'Z' : ''))  
      frmFormData.append("ProId", (neWServiceType ? neWServiceType : '3694') )  
      frmFormData.append("Funding", (neWFundingType ? neWFundingType : 'client'))  
      frmFormData.append("AdminNotes", newDescription)  
      frmFormData.append("AssignedAgentIds",NewCarerAssignmentIds)
       
      console.log(frmFormData)
      //return null

      let sURL = "HMCareTask/recurringtask/add/";
      
      api.post(sURL,frmFormData)
      .then((Response)=>{
          
          let UpdatedDataObj = Response.data;              
          if(UpdatedDataObj!=null){
            setdata([...data,UpdatedDataObj]);  
        }      

      }).catch(error => {
          setError(error);     
          //console.log({error})
      });
      
  }

  const handleAgentSelectChange = (selectedOption) => {

    var options = selectedOption.target.options;
    var value = [];
    var sNames = "";
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
        if(sNames!="") sNames = sNames + ','
        sNames = sNames + options[i].label;
      }
    }    
  setselectedAssignedAgents(value);
  //setselectedAssignedAgentsNames(sNames);
  //console.log(`Option selected:`, value);
  //console.log(`Option selected:`, sNames);
  };

  //===============================================================================================================
       
  const iContainerLengthClass = "4";
       
  return (
    <>

    {/* {data && data.length == 0 &&  <Block><div>No Recurring Visits configured</div></Block>   }  */}
    {/* {data && data.length > 0 &&  */}
    <Block>
      <br></br>
        <Row className="g-gs">
      
        <Col sm="4" xl="3" xxl={iContainerLengthClass} key="Monday">
          <Card className="text-center h-100" border="primary">
            <Card.Header>Monday</Card.Header>
            <Card.Body>
            {data && data.length > 0 && data.filter(p=>p.taskDay == "Monday").map((item) => (   
            <RecurringItemDisplay key={item.recurringTaskId} {...item} />
            ))}           
            <span><Button variant="outline-info" size="sm" onClick={()=>AddButtonClick("Monday")} >+ Add Repeat Schedule</Button></span>
            </Card.Body>
          </Card>
        </Col>

        <Col sm="4" xl="3" xxl={iContainerLengthClass} key="Tuesday">
          <Card className="text-center h-100" border="primary">
            <Card.Header>Tuesday</Card.Header>
            <Card.Body>
            {data && data.length > 0 && data.filter(p=>p.taskDay == "Tuesday").map((item) => (   
            <RecurringItemDisplay key={item.recurringTaskId} {...item} />
            ))}       
            <span><Button variant="outline-info" size="sm" onClick={()=>AddButtonClick("Tuesday")} >+ Add Repeat Schedule</Button></span>    
            </Card.Body>
          </Card>
        </Col>

        <Col sm="4" xl="3" xxl={iContainerLengthClass} key="Wednesday">
          <Card className="text-center h-100" border="primary">
            <Card.Header>Wednesday</Card.Header>
            <Card.Body>
            {data && data.length > 0 && data.filter(p=>p.taskDay == "Wednesday").map((item) => (   
            <RecurringItemDisplay key={item.recurringTaskId} {...item} />
            ))}           
            <span><Button variant="outline-info" size="sm" onClick={()=>AddButtonClick("Wednesday")} >+ Add Repeat Schedule</Button></span>
            </Card.Body>
          </Card>
        </Col>

        <Col sm="4" xl="3" xxl={iContainerLengthClass} key="Thursday">
          <Card className="text-center h-100" border="primary">
            <Card.Header>Thursday</Card.Header>
            <Card.Body>
            {data && data.length > 0 && data.filter(p=>p.taskDay == "Thursday").map((item) => (   
            <RecurringItemDisplay key={item.recurringTaskId} {...item} />
            ))}        
            <span><Button variant="outline-info" size="sm" onClick={()=>AddButtonClick("Thursday")} >+ Add Repeat Schedule</Button></span>   
            </Card.Body>
          </Card>
        </Col>

        <Col sm="4" xl="3" xxl={iContainerLengthClass} key="Friday">
          <Card className="text-center h-100" border="primary">
            <Card.Header>Friday</Card.Header>
            <Card.Body>
            {data && data.length > 0 && data.filter(p=>p.taskDay == "Friday").map((item) => (   
            <RecurringItemDisplay key={item.recurringTaskId} {...item} />
            ))}           
            <span><Button variant="outline-info" size="sm" onClick={()=>AddButtonClick("Friday")} >+ Add Repeat Schedule</Button></span>
            </Card.Body>
          </Card>
        </Col>

        <Col sm="4" xl="3" xxl={iContainerLengthClass} key="Saturday">
          <Card className="text-center h-100" border="primary">
            <Card.Header>Saturday</Card.Header>
            <Card.Body>
            {data && data.length > 0 && data.filter(p=>p.taskDay == "Saturday").map((item) => (   
            <RecurringItemDisplay key={item.recurringTaskId} {...item} />
            ))}           
            <span><Button variant="outline-info" size="sm" onClick={()=>AddButtonClick("Saturday")} >+ Add Repeat Schedule</Button></span>
            </Card.Body>
          </Card>
        </Col>

        <Col sm="4" xl="3" xxl={iContainerLengthClass} key="Sunday">
          <Card className="text-center h-100" border="primary">
            <Card.Header>Sunday</Card.Header>
            <Card.Body>
            {data && data.length > 0 && data.filter(p=>p.taskDay == "Sunday").map((item) => (   
            <RecurringItemDisplay key={item.recurringTaskId} {...item} />
            ))}           
            <span><Button variant="outline-info" size="sm" onClick={()=>AddButtonClick("Sunday")} >+ Add Repeat Schedule</Button></span>
            </Card.Body>
          </Card>
        </Col>      

</Row>
</Block>      
{/* }    */}

{/* Pop-up Modal (Add new schedule) */}

<Modal show={formModal.opened} onHide={closeFormModal} size="lg" backdrop="static">
            <Form ref={modalForm} onSubmit={handleFormSubmit}>
                <Modal.Header closeButton>
                <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
                </Modal.Header>                
                <Modal.Body>
   

                     <Row className="g-gs">                        
                        <Col sm="4">
                            <Form.Group>
                                <Form.Label htmlFor="eventStartDate" >Starts Time</Form.Label>
                                <Row className="g-2">                                  
                                    <Col xs="5">
                                        <div className="form-control-wrap">
                                            <TimePicker id="eventStartTime" value={formModal.eventStartTime??""} placeholder="hh:mm"/>
                                        </div>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>
                        <Col sm="4">
                            <Form.Group>
                                <Form.Label htmlFor="eventEndDate">End Time</Form.Label>
                                <Row className="g-2">                                  
                                    <Col xs="5">
                                        <div className="form-control-wrap">
                                            <TimePicker id="eventEndTime" value={formModal.eventEndTime??""} placeholder="hh:mm"/>
                                        </div>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>  
                        
                        <Col xs="12">
                            <Form.Group>
                            <Form.Label>Assigned Carers</Form.Label>
                            <div className="form-control-wrap">
                                {!stafflist && <div title="Staff" content="container"><Spinner animation="border" variant="primary" /></div>}    
                                {stafflist && <Select onChange={handleAgentSelectChange} multiple id="carerAssignmentIds" defaultValue={formModal.carerAssignmentIds}  >                               
                                    {
                                    stafflist && stafflist.map((staff)=>
                                    <option value={staff.agentId}>{staff.name}</option>                                    
                                    )}                                
                                </Select>}
                            </div>     
                            </Form.Group>                       
                        </Col>                     
                    
                        <Col xs="6">
                            <Form.Group>
                            <Form.Label>Service Type</Form.Label>
                            <div className="form-control-wrap">
                                {!serviceList && <div title="Staff" content="container"><Spinner animation="border" variant="primary" /></div>}       
                                <Form.Select id="ServiceType" defaultValue={formModal.ServiceType}>
                                    {
                                    serviceList && serviceList.map((service)=>
                                    <option value={service.id}>{service.value}</option>                                    
                                    )}                                
                                </Form.Select>
                            </div>     
                            </Form.Group>                       
                        </Col>

                        <Col xs="12">
                            <Form.Group>
                                <Form.Label htmlFor="eventDescription">Admin Notes</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="eventDescription" as="textarea" placeholder="Admin Notes" defaultValue={formModal.eventDescription} />
                                </div>
                            </Form.Group>
                        </Col>                 

                        <Col xs="6">                        
                        <Form.Label>Funding </Form.Label>
                            <div className="form-control-wrap">
                                <Form.Select id="fundingType" value={formModal.fundingType}>                                
                                    <option value="client">Client</option>
                                    <option value="council">Council</option>                                
                                </Form.Select>
                            </div>
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer>                    
                    <Button variant="danger" onClick={closeFormModal}>Discard</Button>
                    {formModal.action === 'add' && <Button variant="primary" type="submit" onClick={handleAddEvent}>Add Event</Button>}                    
                </Modal.Footer>
            </Form>
        </Modal>

</>                          


  )
}


export default RecurringTasks